<!--
 * @Copyright: 12308
 * @Author: xuxinxiang
 * @Date: 2020-04-10 17:00:31
 * @LastEditTime: 2022-02-16 09:55:28
 * @Description:
 -->
<template>
    <div
        class="layout-box"
        onselectstart="return false"
        onselect="return false"
        oncontextmenu="return false"
    >
        <PublicHead></PublicHead>
        <div class="layout-main">
            <LeftMenu :tree="$route.matched[0].meta.tree"></LeftMenu>
            <div class="right">
                <div class="right-main">
                    <Crumbs></Crumbs>
                    <router-view></router-view>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PublicHead from "./head.vue";
import LeftMenu from "./left-menu.vue";
import Crumbs from "./crumbs.vue";
import { getProduct } from "@/api/gm/api-product";
import { resetRouter } from "@/router";
import { treeSame } from "@/router/product";
import Vue from "vue";

export default {
    data() {
        return {
            data: {}
        };
    },
    beforeRouteEnter(to, from, next) {
        // 权限校验
        getProduct(to.meta.pid).then(res => {
            if (res.code === 0) {
                if (
                    !treeSame(
                        res.data.catalogTree[0].children,
                        to.matched[0].meta.tree
                    )
                ) {
                    resetRouter();
                    next(to);
                } else {
                    next();
                }
            } else {
                Vue.prototype.$message.error(res.msg);
            }
        });
    },
    components: {
        PublicHead,
        LeftMenu,
        Crumbs
    }
};
</script>
<style lang="less" scoped>
/deep/html,
body {
    overflow: unset;
}
.layout-box {
    background: #f2f6ff;
    .layout-main {
        min-width: 1100px;
        display: flex;
        .right {
            width: 82%;
            min-width: 900px;
            height: calc(100vh - 80px);
            overflow-y: auto;
            margin-top: 0px;
            .right-main {
                width: 92%;
                margin: 0 auto;
                .crumbs {
                    padding: 1.2vw 0px;
                    /deep/ul {
                        display: inline-block;
                        margin: 0px 0px 0px 5px;
                        padding: 0;
                        li {
                            padding: 0;
                            list-style: none;
                            display: inline-block;
                            font-size: 16px;
                            color: #535353;
                            a {
                                color: #535353;
                                font-size: 16px;
                                text-decoration: none;
                                &:hover {
                                    color: #214d98;
                                }
                            }
                            img {
                                margin: 0 9px 0px 10px;
                            }
                            &:last-child {
                                img {
                                    display: none;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

@media (max-width: 1024px) {
    .layout-box {
        .layout-main {
            min-width: unset;
            width: 100%;
            .right {
                width: 100%;
                min-width: unset;
                height: calc(100vh - 60px);
                /*兼容 IOS<11.2*/
                padding-bottom: constant(safe-area-inset-bottom);
                /*兼容 IOS>11.2*/
                padding-bottom: env(safe-area-inset-bottom);

                .right-main {
                    .crumbs {
                        padding: 15px 0px;
                        /deep/.icon_home {
                            float: left;
                            position: relative;
                            top: 3px;
                        }
                        /deep/ul {
                            width: calc(100% - 22px);
                            display: inline-block;
                            margin: 0px 0px 0px 7px;
                            li {
                                font-size: 14px;
                                img {
                                    margin: 0 5px 0px 6px;
                                }
                                a {
                                    font-size: 14px;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/front/components/layout.vue